module.exports = __webpack_public_path__ + "media/es_slide27_programa3.f89bb847.mp4";